// @ts-nocheck
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import weekday from 'dayjs/plugin/weekday';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { MERIDIEM_TYPE, UNITS } from './constants';
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(weekday);
dayjs.extend(customParseFormat);
var momentGenerator = function momentGenerator(_format, granularity) {
  var _ref;
  if (_format === void 0) {
    _format = 'MM/DD/YYYY';
  }
  var getDecadeBegin = function getDecadeBegin(d) {
    var y = dayjs(d).year();
    var anchorYear = 2018;
    var unitYearsOfPanel = Math.floor((y - 2018) / 12);
    return anchorYear + unitYearsOfPanel * 12;
  };
  return _ref = {
    diff: function diff(end, start, granularity) {
      if (granularity === void 0) {
        granularity = granularity;
      }
      return dayjs(end, typeof end === 'string' ? _format : undefined).diff(dayjs(start, typeof start === 'string' ? _format : undefined), granularity);
    },
    format: function format(date) {
      return typeof date === 'string' ? dayjs(date, _format).format(_format) : dayjs(date).format(_format);
    },
    getNow: function getNow() {
      return dayjs().toDate();
    },
    getFixedDate: function getFixedDate(string) {
      if (string === '') return null;
      return dayjs(string, _format).toDate();
    },
    getStartDate: function getStartDate(date, detail) {
      if (detail === 'decade') {
        return new Date(getDecadeBegin(date), 0, 1);
      }
      return typeof date === 'string' ? dayjs(date, _format).startOf(detail).toDate() : dayjs(date).startOf(detail).toDate();
    },
    getEndDate: function getEndDate(date, detail, isDouble) {
      if (isDouble === void 0) {
        isDouble = false;
      }
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      if (detail === 'decade') {
        if (isDouble) {
          return new Date(getDecadeBegin(date) + 23, 11, 31);
        } else {
          return new Date(getDecadeBegin(date) + 11, 11, 31);
        }
      }
      return clone.endOf(detail).toDate();
    },
    getWeekDay: function getWeekDay(date) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.weekday();
    },
    getYear: function getYear(date) {
      return typeof date === 'string' ? dayjs(date, _format).year() : dayjs(date).year();
    },
    getMonth: function getMonth(date) {
      return typeof date === 'string' ? dayjs(date, _format).month() : dayjs(date).month();
    },
    getDate: function getDate(date) {
      return typeof date === 'string' ? dayjs(date, _format).toDate() : dayjs(date).toDate();
    },
    getHour: function getHour(date) {
      return typeof date === 'string' ? dayjs(date, _format).hour() : dayjs(date).hour();
    },
    getMinute: function getMinute(date) {
      return typeof date === 'string' ? dayjs(date, _format).minute() : dayjs(date).minute();
    },
    getSecond: function getSecond(date) {
      return typeof date === 'string' ? dayjs(date, _format).second() : dayjs(date).second();
    },
    getMeridiem: function getMeridiem(date) {
      var currentHour = typeof date === 'string' ? dayjs(date, _format).hour() : dayjs(date).hour();
      if (currentHour < 12) {
        return MERIDIEM_TYPE.AM;
      } else {
        return MERIDIEM_TYPE.PM;
      }
    },
    addYear: function addYear(date, diff) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.add(diff, 'year').toDate();
    },
    addMonth: function addMonth(date, diff) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.add(diff, 'month').toDate();
    },
    addDate: function addDate(date, diff, unit) {
      if (unit === void 0) {
        unit = 'day';
      }
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      if (unit === UNITS.DECADE) {
        return clone.add(12 * diff, 'year').toDate();
      } else {
        return clone.add(diff, unit).toDate();
      }
    },
    subtractDate: function subtractDate(date, diff, unit) {
      if (unit === void 0) {
        unit = 'day';
      }
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      if (unit === UNITS.DECADE) {
        return clone.subtract(12 * diff, 'year').toDate();
      } else {
        return clone.subtract(diff, unit).toDate();
      }
    },
    setYear: function setYear(date, year) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.year(year).toDate();
    },
    setMonth: function setMonth(date, month) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.month(month).toDate();
    },
    setDate: function setDate(date, num) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.date(num).toDate();
    },
    setHour: function setHour(date, hour) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.hour(hour).toDate();
    },
    setMinute: function setMinute(date, minute) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.minute(minute).toDate();
    },
    setSecond: function setSecond(date, second) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      return clone.second(second).toDate();
    },
    setMeridiem: function setMeridiem(date, meridiem) {
      var clone = typeof date === 'string' ? dayjs(date, _format).clone() : dayjs(date).clone();
      if (meridiem === MERIDIEM_TYPE.PM) {
        if (clone.hour() < 12) {
          return clone.add(12, 'h').toDate();
        } else {
          return clone.toDate();
        }
      } else {
        if (clone.hour() < 12) {
          return clone.toDate();
        } else {
          return clone.subtract(12, 'h').toDate();
        }
      }
    },
    // Compare
    isAfter: function isAfter(date1, date2, unit) {
      if (unit === void 0) {
        unit = granularity;
      }
      return dayjs(date1, typeof date1 === 'string' ? _format : undefined).isAfter(dayjs(date2, typeof date2 === 'string' ? _format : undefined), unit);
    },
    isBefore: function isBefore(date1, date2, unit) {
      if (unit === void 0) {
        unit = granularity;
      }
      return dayjs(date1, typeof date1 === 'string' ? _format : undefined).isBefore(dayjs(date2, typeof date2 === 'string' ? _format : undefined), unit);
    },
    isSameOrAfter: function isSameOrAfter(date1, date2, unit) {
      if (unit === void 0) {
        unit = granularity;
      }
      return dayjs(date1, typeof date1 === 'string' ? _format : undefined).isSameOrAfter(dayjs(date2, typeof date2 === 'string' ? _format : undefined), unit);
    },
    isSameOrBefore: function isSameOrBefore(date1, date2, unit) {
      if (unit === void 0) {
        unit = granularity;
      }
      return dayjs(date1).isSameOrBefore(dayjs(date2), unit);
    },
    isSame: function isSame(date1, date2, unit) {
      if (unit === void 0) {
        unit = granularity;
      }
      if (typeof date1 !== typeof date2) {
        return false;
      }
      var boo1 = dayjs(date1, typeof date1 === 'string' ? _format : undefined).isSame(dayjs(date2, typeof date2 === 'string' ? _format : undefined), unit);
      return boo1;
    },
    isValidate: function isValidate(date) {
      return dayjs(date, typeof date === 'string' ? _format : undefined, true).isValid();
    }
  }, _ref["diff"] = function diff(date1, date2, unit) {
    if (unit === void 0) {
      unit = granularity;
    }
    return dayjs(date2, typeof date2 === 'string' ? _format : undefined).diff(dayjs(date1, typeof date1 === 'string' ? _format : undefined), unit);
  }, _ref.daysInMonth = function daysInMonth(date) {
    return dayjs(date).daysInMonth();
  }, _ref;
};
export default momentGenerator;